module.exports = __webpack_public_path__ + "img/Landing_Black.ffc1b9b0.svg";